// extracted by mini-css-extract-plugin
module.exports = {"taskSheet":"TaskSideSheet_taskSheet__1OxXy","taskSheetContainer":"TaskSideSheet_taskSheetContainer__2PjQV","scrollContainer":"TaskSideSheet_scrollContainer__2tnEp"};